import React from 'react';

import { IconHolder } from './UploadIcon.styles';

function UploadIcon({ icon }) {
  return <IconHolder>{icon}</IconHolder>;
}

export default UploadIcon;
